import styled from '@emotion/styled';
import { MainActionButton } from 'components/navV3/PostAuthMobile/sharedStyles.styles';
import { FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const StyledMainActionButton = styled(MainActionButton)`
  ${MEDIA_QUERY.MOBILE} {
    padding-top: ${SPACING.XS};
  }
  .react-toggle {
    .react-toggle-track {
      height: 24px !important;
      width: 48px !important;
    }
    .react-toggle-thumb {
      width: 20px !important;
      height: 20px !important;
      top: 2px !important;
    }
    &.react-toggle--checked .react-toggle-thumb {
      left: 26px !important;
    }
  }
  label {
    ${MEDIA_QUERY.TABLET} {
      margin-bottom: 0;
    }
    font-weight: ${FONT.WEIGHT.SEMI_BOLD};
    cursor: pointer;
  }
`;
